/* 学年フィルター（チップ）
   仕様：age_ui_spec.md 第5章
   - data-grade="" は「ぜんぶ」
   - 各商品 <li.grid__item data-grades="youji low ..."> を見て出し分け
   - URL ?grade=low で初期選択（広告の着地用）
*/
(function () {
  const VALID = ['youji', 'low', 'mid', 'high', 'set'];

  class AgeFilter extends HTMLElement {
    connectedCallback() {
      this.chips = Array.from(this.querySelectorAll('.age-chip'));
      // 対象一覧と商品セレクタ（属性で上書き可。既定はコレクションページ）
      const gridSel = this.dataset.grid || '#product-grid';
      const itemSel = this.dataset.item || '.grid__item';
      // 一覧（同じセクション内のグリッド）を探す
      this.grid = document.querySelector(gridSel)
        || this.closest('.collection')?.querySelector('#product-grid')
        || document.querySelector('#product-grid');
      if (!this.grid) return;
      this.items = Array.from(this.grid.querySelectorAll(itemSel));
      // 並び順復元用に元の順番を覚えておく
      this.items.forEach((item, i) => { item.dataset.origIdx = i; });

      this.chips.forEach((chip) =>
        chip.addEventListener('click', () => this.select(chip.dataset.grade, true))
      );

      // URL ?grade=low を初期値に
      const param = new URLSearchParams(window.location.search).get('grade');
      const initial = VALID.includes(param) ? param : '';
      this.select(initial, false);
    }

    select(grade, updateUrl) {
      // チップの見た目
      this.chips.forEach((chip) =>
        chip.setAttribute('aria-pressed', chip.dataset.grade === grade ? 'true' : 'false')
      );

      // 商品の出し分け
      this.items.forEach((item) => {
        const grades = (item.dataset.grades || '').split(' ').filter(Boolean);
        const show = grade === ''
          || (grade === 'set' ? item.hasAttribute('data-set') : grades.includes(grade));
        item.classList.toggle('age-hidden', !show);
      });

      // セット絞り込み時はセット内容の点数が少ない順（2点→3点→…）に並べ替え
      this.reorder(grade);

      // URLを書き換え（共有・戻る対応。ページ再読み込みはしない）
      if (updateUrl) {
        const url = new URL(window.location.href);
        if (grade) url.searchParams.set('grade', grade);
        else url.searchParams.delete('grade');
        window.history.replaceState({}, '', url);
      }
    }

    reorder(grade) {
      if (grade === 'set') {
        if (!window.plBsGetProduct) {
          // 商品データ(bottomsheet)読み込み前なら少し待って再試行
          setTimeout(() => { if (window.plBsGetProduct) this.reorder('set'); }, 300);
          return;
        }
        const size = (item) => {
          const el = item.querySelector('[data-pl-bs-id]');
          const pd = el && window.plBsGetProduct(el.getAttribute('data-pl-bs-id'));
          if (!pd) return 99;
          const m = (pd.title || '').match(/(\d+)\s*点/);   // タイトルの「◯点」表記を優先
          if (m) return parseInt(m[1], 10);
          return pd.contents ? pd.contents.length : 99;
        };
        this.items
          .filter((item) => item.hasAttribute('data-set'))
          .sort((a, b) => size(a) - size(b) || a.dataset.origIdx - b.dataset.origIdx)
          .forEach((item) => this.grid.appendChild(item));
      } else {
        // 元の並び（売れ筋順）に戻す
        this.items
          .slice()
          .sort((a, b) => a.dataset.origIdx - b.dataset.origIdx)
          .forEach((item) => this.grid.appendChild(item));
      }
    }
  }

  if (!customElements.get('age-filter')) {
    customElements.define('age-filter', AgeFilter);
  }
})();
